module.exports = __webpack_public_path__ + "media/images/feature-2-b550d7b9.png";